module.exports = __webpack_public_path__ + "static/media/1.da5677e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/4002/1.jpg
// module id = 660
// module chunks = 0